export default "__VITE_ASSET__3f75983f__"